export { default } from "./SpeedDialAction.js";
export { default as speedDialActionClasses } from "./speedDialActionClasses.js";
export * from "./speedDialActionClasses.js";